/**
 * `StoragePort`（索引 Issue #498 の段階 4）— **文書をどこに置くか**。
 *
 * | メソッド | 中身 |
 * |---|---|
 * | `load()` | 文書を読む（Promise 可。無ければ null） |
 * | `save(doc)` | 丸ごと置換で書く（Promise 可） |
 * | `loadAux(key)` / `saveAux(key, value)` | 文書に載せないもの（イン点・パネルの大きさなど） |
 * | `status()` | `{ saving, savedAt, error, dirty }` |
 *
 * **丸ごと置換**なのは、文書が数 KB で編集者が 1 人だから（差分を持つと壊れ方が難しくなる）。
 * 実装はサーバーの replay の timing（`editorPorts/ocgStorage.js`。`OcgGetTiming` / `OcgSetTiming`）。
 */
import { definePort } from './define';

export const StoragePort = definePort('StoragePort', {
  load: () => null,
  save: () => {},
  loadAux: () => null,
  saveAux: () => {},
  status: () => ({ saving: false, savedAt: null, error: null, dirty: false }),
});
